import { createStore, sample } from 'effector'

import { constants } from '@/shared/config'

import type { ChatSettings, MessageLimitSetting } from '../api'
import * as connModel from './model.conn'
import * as userModel from './model.user'

export const $chatSettings = createStore<ChatSettings>({
    maintenance: { enabled: false },
    message_limit: {
        user: constants.CHAT_MESSAGE_MAX_LENGTH_USER,
        admin: constants.CHAT_MESSAGE_MAX_LENGTH_ADMIN,
    },
})

export const $isMaintenance = $chatSettings.map<boolean>((settings) => settings.maintenance.enabled)
export const $messageLimits = $chatSettings.map<MessageLimitSetting>((settings) => settings.message_limit)

// receive chat settings on login
sample({
    clock: userModel.loginFx.doneData,
    fn: ({ chat_settings }) => chat_settings,
    target: $chatSettings,
})

// update chat settings on event
sample({
    clock: connModel.chatSettingsUpdated,
    target: $chatSettings,
})
